import {
  BLOG_ARTICLE,
  BLOG_ARTICLES,
  GetArticleRequest,
  GetArticleResponse,
  GetArticlesRequest,
  GetArticlesResponse,
} from "@project/shared-types";
import apiFetchPost from "./apiClient";
export const GetArticlesAPI = async (dataRequest: GetArticlesRequest) => {
  try {
    const response = await apiFetchPost<
      GetArticlesRequest,
      GetArticlesResponse
    >(BLOG_ARTICLES, dataRequest);
    return response;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};

export const GetArticleAPI = async (dataRequest: GetArticleRequest) => {
  try {
    const response = await apiFetchPost<GetArticleRequest, GetArticleResponse>(
      BLOG_ARTICLE,
      dataRequest
    );
    return response;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};
